import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate';
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import download from 'downloadjs';
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination'
// import Vue from "vue";
import Vue from "vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
// import csvHelper from '../importjsontocsv';

export default {
  name: 'brandwisestockreport',
  components: {
    Paginate,
    Pagination,
    DatePicker,
    download,
    JsonExcel,
    Loader
  },
  props: [],
  fields: [],

  data() {
    return {
      flipkartid:'',
      filterproductid: '',
      clientproductid: '',
      rackid: '',
      limitExeed: false,

      downloadype: '',
      exceedsize: false,
      listMerchantData: [],
      listStockReportData: [],
      listStockReportDatacsv: [],
      listStockReportDataforxls: [],
      dataFilter2: '',
      listStockReportFinalData: [],
      listsubinventoryData: [],
      subinventory: '',
      csvFields: [],
      csvFieldsForXls: {},
      // perPage: 10,
      // pageno: 0,
      // totalPage: 0,
      totalPage: 0,
      totalRows: 0,
      currentPage: 1,
      pageLimit: 10,

      POID: '',
      InvoiceID: '',
      RackID: '',
      ProductID: '',
      merchantname: '',
      fromdate: '',
      todate: '',
      isLoading: false,
      isLoadingforxls: false,
      formattedDate: '',
      reportname: '',
      resultCount: '',
      listClientData: [],
      listWarehouseData: [],
      ClientErr: '',
      WarehouseErr: '',
      searchFlag: false,
      showSelectWarehouse: false,
      showSelectClient: false,
      clientid: '',
      warehouseid: '',
      warehouse: '',
      client: '',
      stocktype: '',
      stocktypeErr: '',
      user_type: '',
      inventory: 'All',
      userid: '',
      show: false,
      download: true,
      recordLimit: 0,
      exceedFlag: false,
      lesslimitflag: false
    }
  },
  computed: {

  },
  filters: {
    moment: function(date) {
      if (!date) return '';
      return moment(date).format('DD-MM-YY hh:mm:ss');
    }
  },
  mounted() {
    var today = new Date();
    this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
    this.reportname = "brandwisestockreport"
    this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
    var permissionEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.createdbyEmail = userdetail.email;
    this.userid = userdetail.userid;
    this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
    //this.getStockReportData();
    this.user_type = userdetail.utype;
    switch (this.user_type) {
      case 'system_user':
        this.showSelectClient = true;
        this.showSelectWarehouse = true;
        // this.getClientList();
        // this.getWarehouseList();
        break;

      case 'client_user':
        this.clientid = userdetail.clientid;
        this.client = this.clientid;
        // this.getWarehouseList();
        this.getMerchantList();
        this.showSelectWarehouse = true;
        break;

      case 'warehouse_user':
        this.loginUserEmail = userdetail.email;
        this.warehouseid = userdetail.warehouseid;
        this.warehouse = this.warehouseid;
        this.showSelectClient = true;
        // this.getClientList();

        var roleids = userdetail.roleid.split(',');
        for (var i = 0; i < roleids.length; i++) {
          if (roleids[i] == 40) {
            this.purchasingManager = parseInt(roleids[i]);
          }
          if (roleids[i] == 41) {
            this.isInwardUserForPO = true;
          }
        }
        break;

      default:
        this.$alertify.error("Unauthorised user, Please contact your system admin");
        break
    }
    this.getRecordLimit()

  },
  methods: {


    export (data, filename, mime) {
      let blob = this.base64ToBlob(data, mime)
      download(blob, filename, mime)
    },

    base64ToBlob(data, mime) {
      let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
      let bstr = atob(base64)
      let n = bstr.length
      let u8arr = new Uint8ClampedArray(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {
        type: mime
      })
    },

    Choosetype() {
      this.show = true;
      this.download = false;
      if (!this.limitExeed) {
        this.getStockReportxslData(3)
      }


    },

    startDownload() {
      this.isLoadingforxls = true;
    },
    finishDownload() {
      this.isLoadingforxls = false;
    },
    getRecordLimit() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({

      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getRecordLimit',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          if (result.data) {
            this.recordLimit = result.data.data;


          }
        }, error => {
          console.error(error)
        })
    },
    // getClientList() {
    //   if (window.localStorage.getItem("clientList") !== null) {
    //     var clientListEncrypt = window.localStorage.getItem('clientList');
    //     var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
    //     var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
    //     this.listClientData = JSON.parse(plaintextclient);
    //   } else {
    //     var userToken = window.localStorage.getItem('userToken');
    //     var myStr = userToken.replace(/"/g, '');
    //     this.pageno = 0;

    //     this.input = ({
    //       warehouseid: this.warehouseid,
    //     });

    //     axios({
    //         method: 'POST',
    //         'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
    //         'data': this.input,
    //         headers: {
    //           'Authorization': 'Bearer ' + myStr,
    //         }
    //       })
    //       .then(result => {
    //         this.listClientData = result.data.data;
    //       }, error => {
    //         console.error(error);
    //       });
    //   }
    // },

    // getWarehouseList() {
    //   if (window.localStorage.getItem("warehouseList") !== null) {
    //     var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
    //     var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
    //     var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
    //     this.listWarehouseData = JSON.parse(plaintextwarehouse);
    //   } else {
    //     var userToken = window.localStorage.getItem('userToken')
    //     var myStr = userToken.replace(/"/g, '');
    //     this.pageno = 0;
    //     this.input = ({
    //       clientid: this.clientid,
    //     });

    //     axios({
    //         method: 'POST',
    //         'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
    //         'data': this.input,
    //         headers: {
    //           'Authorization': 'Bearer ' + myStr
    //         }
    //       })
    //       .then(result => {
    //         this.listWarehouseData = result.data.data;
    //       }, error => {
    //         console.error(error)
    //       })
    //   }
    // },

    // clientSelected() {
    //   if (this.clientid != this.client) {
    //     this.clientid = this.client;
    //     if (this.user_type != 'warehouse_user') {
    //       this.listWarehouseData = []
    //       this.getWarehouseList();
    //       if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
    //         this.warehouse = this.warehouseid = '';
    //       } else {
    //         this.warehouse = ''
    //       }
    //     } else {
    //       if (this.warehouseid && this.clientid);
    //       this.getMerchantList();
    //       this.getsubinventoryList();
    //       // this.getStockReportData();
    //     }
    //   }
    //   this.listStockReportData = [];
    //   this.pageno = this.totalPage = 0;
    // },

    // warehouseSelected() {
    //   this.warehouseid = this.warehouse;
    //   this.pageno = this.totalPage = 0;
    //   if (this.warehouseid) {
    //     if (this.clientid) {
    //       // this.getStockReportData();
    //     } else {
    //       this.getClientList();
    //     }
    //   }
    // },
    getMerchantList() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        clientid: this.clientid,
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'merchantList',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          if (result.data && result.data.length > 0) {
            this.listMerchantData = result.data;

          }
        }, error => {
          console.error(error)
        })
    },
    getsubinventoryList() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        clientid: this.clientid,
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getSubInventoryList',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          if (result.data && result.data.length > 0) {
            this.listsubinventoryData = result.data;

          }
        }, error => {
          console.error(error)
        })
    },
    getStockReportDataSearch() {
      this.currentPage = 1;
      this.totalPage = 0;
      this.searchFlag = true;
      this.getStockReportData(2);
    },
    //to get client list
    getStockReportData(csvCheck = 0) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var fr_date = '';
      var to_date = '';
      var dataFilter = {};
      this.exceedFlag = false;
      if (csvCheck == 2) {
        this.show = false;
        this.download = true;
        this.limitExeed = false

      }
      this.searchFlag = true;


      // this.ClientErr = '';
      if (window.localStorage.getItem('selectedClient')==='undefined') {
        this.$alertify.error(this.$t('common.clientError'))
        this.pageNo = this.totalPage = 0;
        this.listStockReportData = [];
        return false;
      }
      if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
        this.$alertify.error(this.$t('common.warehouseError'))
        this.pageNo = this.totalPage = 0;
        this.listStockReportData = [];
        return false;
      }

      this.isLoading = true;
      if (this.fromdate) {
        fr_date = this.dateFormat(this.fromdate)
      }
      if (this.todate) {
        to_date = this.dateFormat(this.todate)
      }
      if (csvCheck == 2)
        this.pageno = 0;
        var offset =(this.currentPage - 1) * 10
        var limit =this.pageLimit
      this.input = ({
        "clientid": window.localStorage.getItem('selectedClient'),
        "warehouseid": window.localStorage.getItem('selectedWarehouse'),
        "clientproductid":this.clientproductid,
        "productid": this.filterproductid,
        "rackid": this.rackid,
        "flipkartid": this.flipkartid,
        "offset":offset.toString(),
        "limit":limit.toString(),
        // 'csvData': csvCheck,
      })

      Object.entries(this.input).forEach(([k, v]) => {
        let skipkeys = ['offset', 'limit', 'csvData'];
        if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
          dataFilter[k] = v;
        }
      })

      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'prodcutstocklist',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          if (result.data.data[0].ErrorCode == -1) {
            this.listStockReportData = [];
            this.resultCount = 0;
            this.totalRows = 0;
            this.$alertify.error(result.data.data[0].msg);
          } else {
            this.listStockReportData = result.data.data[0].data.data;
            if(this.listStockReportData.length == 0){
              this.$alertify.error(result.data.data[0].msg);

            }else{
              this.$alertify.success(result.data.data[0].msg);

            }


            this.totalRows = result.data.data[0].data.count;
            this.resultCount = result.data.data[0].data.count;
            if (this.totalRows <= this.pageLimit) {
              this.totalPage = 1;
            } else {
              this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
            }
          }
          this.isLoading = false;
        }, error => {
          console.error(error);
        })
    },


    getStockReportxslData(csvCheck = 3) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.searchFlag = true;

      this.show = true;
      this.download = false;

      this.dataFilter2 = [];
      var value = '';
      var str = '';

      if (this.fromdate) {
        fr_date = this.dateFormat(this.fromdate)
      }
      if (this.todate) {
        to_date = this.dateFormat(this.todate)
      }
      if (csvCheck == 2)
        this.pageno = 0;

      this.input = ({
        'clientid': window.localStorage.getItem('selectedClient'),
        'warehouseid': window.localStorage.getItem('selectedWarehouse'),
        'merchantid': this.merchantname,
        'stocktype': this.stocktype,
        'subinventory': this.subinventory,
        'productid': this.ProductID,
        'offset': (this.currentPage - 1) * 10,
        'limit': this.pageLimit,
        'csvData': csvCheck,
        userid: this.userid
      })

      Object.entries(this.input).forEach(([k, v]) => {
        let skipkeys = ['offset', 'limit', 'csvData'];
        if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
          value += k + ':' + v + ','
          this.dataFilter2 = str.concat(value);

        }

      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'brandWiseStockReport',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          if (csvCheck == 3) {
            if (result.data.data.length > 0) {
              this.listStockReportDataforxls = [];

              this.csvFieldsForXls = {
                'clientproductid': 'clientproductid',
                'productname': 'productname',
                'brand': 'brand',
                'mrp': 'mrp',
                'totalqty': 'totalqty',
                'subinventory': 'subinventory',
                'merchantname': 'merchantname',


              };
              this.listStockReportDataforxls = result.data.data;
            } else {
              this.listStockReportDataforxls = [];
              if (result.data.status == true) {
                this.$alertify.success('Report size is large. Please download from Data Transmission -> Download Reports');
              } else {
                this.$alertify.error(result.data.msg.message);
              }
            }


          }

        }, error => {
          console.error(error);
        })
    },
    //to get pagination
    // getPaginationData(currentPage) {
    // 	this.pageno = (currentPage - 1) * this.perPage;
    // 	this.getStockReportData();
    // },

    onPageChange(page) {
      this.currentPage = page;
      this.getStockReportData()
    },
    dateFormat(date) {
      if (!date) return '';
      return moment(date).format('YYYY-MM-DD HH:mm:ss');
    },

    dateFormatFRT(date) {
      if (!date) return '';
      return moment(date).format('DD-MM-YY HH:mm:ss');
    },

    //to reset search form
    resetSearchForm() {
      this.show = false;
      this.download = true;
      this.POID = '';
      this.InvoiceID = '';
      this.RackID = '';
      this.ProductID = '';
      this.fromdate = '';
      this.todate = '';
      this.merchantname = '',
      this.flipkartid='',
      this.filterproductid= '',
      this.clientproductid= '',
      this.rackid= '',
        this.subinventory = '',
        this.pageno = 0;
      this.totalRows = 0;
      this.stocktype = '';
      this.inventory = 'All';
      this.searchFlag = false;
      this.listStockReportData = [];
      if (this.user_type == 'warehouse_user')
        this.client = '';
      else if (this.user_type == 'client_user')
        this.warehouse = '';
      else {
        this.client = '';
        this.warehouse = '';
      }
      //this.getStockReportData();
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/uniware/productstock/productstock.component.js